import React, { Fragment } from 'react';

import PageTitle from 'components/PageTitle';
import RestorePassForm from './RestorePassForm';


const RestorePass = props => {
  return (
    <div className="page-body">
      <PageTitle
        align="center"
        isBackButton={true}>Forgot<br />your password?</PageTitle>

      <div className="content-container">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 offset-lg-4">
              <RestorePassForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RestorePass;